import React from 'react';
import type { AppRoute } from '../../shared/types/routes';
import QuestionnaireHomePage from './components/QuestionnaireHomePage';
import SecurityQuestionnaire from './components/SecurityQuestionnaire';
import TrainHeliosReviewGate from './components/TrainHeliosReviewGate';
import ViewClientQuestions from './components/ViewClientQuestions';
import ExtractQuestions from './components/ExtractQuestions';

/** Questionnaire app routes. Add or change routes here. */
export const questionnaireRoutes: AppRoute[] = [
  { path: '/questionnaire', element: <QuestionnaireHomePage /> },
  { path: '/questionnaire/questions', element: <SecurityQuestionnaire /> },
  { path: '/questionnaire/review', element: <TrainHeliosReviewGate /> },
  { path: '/questionnaire/view-client-questions', element: <ViewClientQuestions /> },
  { path: '/questionnaire/extract-questions', element: <ExtractQuestions /> },
];
